import { services } from "../../services/api";

let pendingBootstrap;

export function bootstrapCsrfSession() {
  if (!pendingBootstrap) {
    pendingBootstrap = services("GET", "csrf-cookie", null)
      .then(response => {
        if (response?.status !== 204 && response?.status !== 200) {
          throw new Error("CSRF session initialization failed");
        }
      })
      .finally(() => { pendingBootstrap = undefined; });
  }
  return pendingBootstrap;
}
